export default __webpack_public_path__ + "static/language-partner-banner-401e9055e9f2f5fe480d0994affe5fac.jpeg";